export default __webpack_public_path__ + "static/media/PrimeTrust.d1699fb0.png";